/**
 * Purpose:
 * Centralized dropdown query/configuration for table-builder mapping selectors.
 *
 * Why:
 * Keeps Syncfusion dropdown filtering settings out of the component class so
 * searchable selector behavior stays easy to reuse and maintain.
 */
import { Query } from '@syncfusion/ej2-data';

export const TABLE_BUILDER_DROPDOWN_FILTER_TYPE = 'Contains';
export const TABLE_BUILDER_DROPDOWN_FILTER_PLACEHOLDER = 'Type to search';
export const TABLE_BUILDER_DROPDOWN_POPUP_HEIGHT = '260px';

/**
 * Base query shared by searchable mapping dropdowns.
 * A no-op query is sufficient here because Syncfusion handles local filtering
 * while the component controls filtering behavior through dedicated inputs.
 */
export const TABLE_BUILDER_DROPDOWN_QUERY = new Query();
